
























import Dialog from '@/components/common/Dialog.vue';
import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({components: {Dialog}})
export default class RecalculationDialog extends Vue {
    @Prop({type: Function, required: true})
    public readonly recalculationHandler: () => Promise<void>;

    protected calculating: boolean = false;

    private get dialog(): Dialog {
        return this.$refs.dialog as Dialog;
    }

    public show(): void {
        this.dialog.show();
    }

    protected recalculate(): void {
        this.calculating = true;

        this.recalculationHandler()
            .then(() => this.dialog.hide())
            .finally(() => this.calculating = false);
    }
}
